import raf             from 'raf';

/**
 * @module
 * This is a module that will be called alot on a big form, so for a marginal speed/memory gain, this module is jQuery free.
 */

let __supportsDateInput = undefined;

const selector = '.Ge-Label'; // I know this goes against the convention of "JS identifiers must be a "data-js-" datatype, but this is going to be used so widely, I don't want one label to fail just becuase it didn't have a class and a datatype.
const formLabel = function(el, app) {
    
    const input = el.querySelector('.Ge-Input') || el.querySelector('.Ge-Select');
    if (!input) {
        return;
    }
    const tag = input.tagName;
    const type = input.getAttribute('type');
    let   inputType = null;
    
    const supportsDateInput = function() {
        if( __supportsDateInput === undefined ){
            const input = document.createElement('input');
            input.setAttribute('type','date');
        
            const notADateValue = 'not-a-date';
            input.setAttribute('value', notADateValue); 
        
            __supportsDateInput = input.value !== notADateValue;
        }

        return __supportsDateInput;
    }

    const init = function() {
        // only inputs and not radio or checkbox ones
        if (!input) {
            return;
        } else {
            if (input.tagName === 'SELECT') {
                inputType = 'select';
            } else if (input.tagName === 'TEXTAREA') {
                inputType = 'textarea';
            } else {
                inputType = input.getAttribute('type').toLowerCase();
            }
            if (inputType && ['radio','checkbox'].indexOf(inputType) >= 0) {
                return;
            }
        }
        // check that the form doesn't start pre-filled
        formLabelCheckValue(false,true);
        // register events
        registerEvents();

        // select/date/textarea/file inputs need help
        if (inputType === 'select' || type === 'date') {
            el.classList.add('Ge-Label--select');
        } else if (inputType === 'textarea') {
            el.classList.add('Ge-Label--textarea');
        }  else if (inputType === 'file') {
            el.classList.add('Ge-Label--file');
        } 

        if( inputType === 'date' && !supportsDateInput() ) {
            input.style.background = "none";
        }

        // ready
        el.classList.add('Ge-Label--ready');
        setTimeout(function() {
            el.classList.add('Ge-Label--animate');
        },800);
    };
    
    const registerEvents = function() {
        input.addEventListener('fieldLoaded',formLabelLoad,false);
        input.addEventListener('fieldValidate',formLabelLoad,false);
        $(input).on('fieldLoaded',formLabelLoad); // belt and braces. triggering events via jQuery is unreliable when listening via addEventListener [sigh]
        $(input).on('fieldValidate',formLabelLoad); // belt and braces. triggering events via jQuery is unreliable when listening via addEventListener [sigh]
        input.addEventListener('blur',formLabelCheckValue);
        input.addEventListener('blur',formLabelBlur);
        input.addEventListener('focus',formLabelFocus);
        if (tag === 'INPUT' && ['radio','checkbox','date','file'].indexOf(type) < 0) {
            input.addEventListener('keyup',formLabelCheckValue);
        }
        input.addEventListener('animationstart', formInputAutFillDetect); // detect browser autofill
    };
    
    // mark the label as focused
    // the input el will get it's own focus state, but the text label only gets a state change if we tell the parent - the label - that focus has occurred
    const formLabelFocus = function () {
        el.classList.add('Ge-Label--focus');
    };
    
    // mark the label as having lost focus
    const formLabelBlur = function () {
        el.classList.remove('Ge-Label--focus');
    };
    
    // mark the label as "loaded" with some input value. This is different from .Ge-Label--focus to seperate two use cases where the label needs to animate (when focused but empty, and when filled and focused/unfocused).
    const formLabelLoad = function (instant) {
        el.classList.add('Ge-Label--loaded');
        // if we're asking to do this animation instantly (eg on page load, so it appears to load in the right state)
        if (instant) {
            // kill all transitions on the label
            el.classList.add('Ge-Label--loaded-instant');
            // remove the instant modifier in the next frame.
            raf(function tick() {
                raf(function tick() {
                    el.classList.remove('Ge-Label--loaded-instant');
                });
            });
        }
    };
    
    // mark the label as not "loaded" with any input value
    const formLabelUnLoad = function () {
        el.classList.remove('Ge-Label--loaded');
    };
    
    // detect if a field is being autofilled by the browser (currently blink/webkit only, but hopefully more browsers).
    // it uses the pseudo element :-webkit-autofill to attach an animation, and then detect if that animation starts.
    // details: https://stackoverflow.com/questions/11708092/detecting-browser-autofill
    const formInputAutFillDetect = function(ev) {
        switch (ev.animationName) {
            case 'onAutoFillStart':
                formLabelLoad(true);
                break;
            case 'onAutoFillCancel':
                // if the input is empty, unload it (move the label back to the center)
                const value = (input.value ? input.value.trim() : '' );
                if ( !value.length && type !== 'date') {
                    formLabelUnLoad();
                }
                break;
        }
    };

    // check if the input has is loaded with a value, and mark the label accordingly.
    const formLabelCheckValue = function (ev,instant) {
        const value = (input.value ? input.value.trim() : '' );
        // mark the label as in use if it wasn't before
        if (( value.length && !el.classList.contains('Ge-Label--loaded') ) || type === 'date') {
            formLabelLoad(instant);
        // mark the label as NOT in use, if it is at the moment
        } else if (!value.length && el.classList.contains('Ge-Label--loaded')) {
            formLabelUnLoad();
        }
    };

    return {
        init: init()
    };
};

formLabel.selector = selector;

export default formLabel;
